<template lang="pug">
.profile
    NavBar(path="info.discount.title" back)
    .content
        .profile-tab(:class="{'is-open': tabOpen === 'basedata'}").profile-tab-basedata
            .profile-head(@click="toggleTab('basedata')")
                .profile-head-line
                    NewTranslation(path="info.discount.student.title")
                .profile-head-toggle
                    font-awesome-icon(icon="chevron-down")
            .profile-body
                section
                    NewTranslation(path="info.discount.student.body")

        .profile-tab(:class="{'is-open': tabOpen === 'preferences'}").profile-tab-preferences
            .profile-head(@click="toggleTab('preferences')")
                .profile-head-line
                    NewTranslation(path="info.discount.senior.title")
                .profile-head-toggle
                    font-awesome-icon(icon="chevron-down")
            .profile-body
                section
                    NewTranslation(path="info.discount.senior.body")

        .profile-tab(:class="{'is-open': tabOpen === 'favorites'}")
            .profile-head(@click="toggleTab('favorites')")
                .profile-head-line
                    NewTranslation(path="info.discount.disability.title")
                .profile-head-toggle
                    font-awesome-icon(icon="chevron-down")
            .profile-body
                section
                    NewTranslation(path="info.discount.disability.body")

        .profile-tab(:class="{'is-open': tabOpen === 'resident'}")
            .profile-head(@click="toggleTab('resident')")
                .profile-head-line
                    NewTranslation(path="info.discount.resident.title")
                .profile-head-toggle
                    font-awesome-icon(icon="chevron-down")
            .profile-body
                section
                    NewTranslation(path="info.discount.resident.body")

        .profile-tab(:class="{'is-open': tabOpen === 'business'}")
            .profile-head(@click="toggleTab('business')")
                .profile-head-line
                    NewTranslation(path="info.discount.business.title")
                .profile-head-toggle
                    font-awesome-icon(icon="chevron-down")
            .profile-body
                section
                    NewTranslation(path="info.discount.business.body")


    TabBar

</template>

<script>
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Button,
  },
  props: ['pagedata'],
  mounted() {
    if (this.pagedata && this.pagedata.tabOpen) this.tabOpen = this.pagedata.tabOpen;
  },
  methods: {
    toggleTab(tabname) {
      if (this.tabOpen === tabname) this.tabOpen = '';
      else this.tabOpen = tabname;
    },
  },
  data() {
    return {
      tabOpen: '',
      passwordOpen: false,
    };
  },
};
</script>

<style lang="sass" scoped>
.content
	padding: 20px 20px 100px
	background-color: #F3F7F8
	min-height: calc(100vh - 92px)
.profile
	&-tab
		background-color: #fff
		border-radius: 10px
		margin-bottom: 20px
	&-head
		height: 68px
		display: flex
		align-items: center
		position: relative
		&-icon
			width: 18px
			height: 100%
			margin-left: 23px
			&.is-bigicon
				width: 22px
				margin-left: 21px
				margin-right: -2px
		&-line
			font-size: 1.25rem
			margin-left: 27px
			color: #454F63
		&-toggle
			width: 20px
			height: 20px
			display: flex
			justify-content: center
			align-items: center
			border-radius: 20px
			border: 1px solid #1DB2D1
			position: absolute
			top: 24px
			right: 20px
			svg
				color: #1DB2D1
				width: 10px
				.is-open &
					transform: rotate(180deg)
	&-body
		border-top: 1px solid #F4F4F6
		padding: 0 20px
		display: none

		.is-open &
			display: block

		.form
			padding-top: 20px

		.field
			display: flex
			flex-direction: column
			& + .field
				margin-top: 20px
			input,
			select
				color: #454F63
				border-radius: 3px
				border: 1px solid #B3BAC8
				padding: 15px 15px 15px 45px
				margin-top: 5px
				background-color: #fff
				font-size: 1rem
				font-family: inherit
				width: 100%
			select,
			input[type="date"]
				-webkit-appearance: textfield
				appearance: textfield
			&-input
				position: relative
				svg
					position: absolute
					bottom: 0
					top: 5px
					left: 20px
					width: 15px
					margin-top: auto
					margin-bottom: auto
		.savebutton
			margin-top: 20px

		.headline
			font-size: 1.25rem
			margin-bottom: 20px

		section
			padding-top: 20px
			padding-bottom: 20px
			& + section
				border-top: 1px solid #F4F4F6

	&-tab-preferences
		.field
			flex-direction: row
			justify-content: space-between
			align-items: center
			input[type="checkbox"]
				-webkit-appearance: none
				padding: 0
				width: 35px
				height: 20px
				display: block
				border-radius: 20px
				background-color: #454F63
				border: none
				position: relative
				&:before
					content: ""
					display: block
					border-radius: 18px
					width: 18px
					height: 18px
					background-color: #fff
					position: absolute
					left: 1px
					top: 1px
			input[type="checkbox"]:checked
				background-color: #1DB2D1
				&:before
					left: auto
					right: 1px
	&-tab-settings
		section
			color: #454F63
			a
				color: #1DB2D1
	&-settings
		&-head
			position: relative
		// &-headline
		&-toggle
			width: 20px
			height: 20px
			display: flex
			justify-content: center
			align-items: center
			border-radius: 20px
			border: 1px solid #1DB2D1
			position: absolute
			top: 2px
			right: 0px
			svg
				color: #1DB2D1
				width: 10px
				.is-open-password &
					transform: rotate(180deg)
		&-body
			display: none
			.is-open-password &
				display: block
</style>
